import React, {useState, useEffect, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {languages} from '../../../App';
import {useMenu} from '../../../hooks/useMenu';
import GuidedConfiguration from './guided-config';
import LoadConfig from './load-config';
import CommandsContext from '../../../context/commandsContext';
import {useTranslation, withTranslation, Trans} from 'react-i18next';
import TimeDate from './time-date';
import SetBluetoothRadio from './setBluetoothRadio';

function Language({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);
  const {onComponent, selected, setSelected, setDisableMenu} = useMenu();
  const {t, i18n} = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  const current = languages.find(item => item.code === i18n.language);
  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  const onRight = useCallback(item => {
    i18n.changeLanguage(item.code);
    onComponent(<SetBluetoothRadio />);
  }, []);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands, onRight}));
  }, []);
  

  return (
    <FullBodyMenuView
      title={t('selectLanguage.title')}
      menuItems={languages}
      initialValue={current?.name}
      onLeftCallback={() => onComponent(<GuidedConfiguration />)}
      onRightCallback={onRight}
    />
  );
}
export default Language;
